import React from 'react'
import PropTypes from 'prop-types'
import Resx from '@/components/Resx'
import {
  FormGroup,
  Label,
  Input
} from 'reactstrap'
import { Validator } from '@/components/validation'
import { NumericInput } from '@/components/inputs'

class BaseInputs extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      name: props.name,
      latinName: props.latinName,
      code: props.code,
      legacyCode: props.legacyCode
    }
  }

  onChange () {
    this.props.onChange({
      name: this.state.name,
      latinName: this.state.latinName,
      code: this.state.code,
      legacyCode: this.state.legacyCode
    })
  }

  changeName (value) {
    this.setState({ name: value },
      () => this.onChange())
  }

  changeLatinName (value) {
    this.setState({ latinName: value },
      () => this.onChange())
  }

  changeCode (value) {
    this.setState({ code: value },
      () => this.onChange())
  }

  changeLegacyCode (value) {
    this.setState({ legacyCode: value },
      () => this.onChange())
  }

  emptyValidValidate ({ value }) {
    if (!value.toString().match('\\S')) {
      return 'CodeLists.EmptyString'
    }
  }

  render () {
    const { isReadOnly } = this.props

    return (
      <React.Fragment>
        <FormGroup>
          <Label><Resx name='Common.Name' />:</Label>
          <Validator name='name' value={this.state.name} onValidate={this.emptyValidValidate} required>
            <Input
              onKeyUp={(e) => this.changeName(e.target.value)}
              onChange={(e) => this.changeName(e.target.value)}
              defaultValue={this.state.name} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Common.LatinName' />:</Label>
          <Validator name='latinName' value={this.state.latinName} onValidate={this.emptyValidValidate} required>
            <Input
              onKeyUp={(e) => this.changeLatinName(e.target.value)}
              onChange={(e) => this.changeLatinName(e.target.value)}
              defaultValue={this.state.latinName} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Common.Code' />:</Label>
          <Validator name='code' value={this.state.code} onValidate={this.emptyValidValidate} required>
            <Input
              onKeyUp={(e) => this.changeCode(e.target.value)}
              onChange={(e) => this.changeCode(e.target.value)}
              defaultValue={this.state.code} readOnly={isReadOnly} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Common.LegacyCode' /></Label>
          <NumericInput
            onKeyUp={(value) => this.changeLegacyCode(value)}
            onChange={(value) => this.changeLegacyCode(value)}
            defaultValue={this.state.legacyCode} />
        </FormGroup>
      </React.Fragment>
    )
  }
}

BaseInputs.propTypes = {
  name: PropTypes.string,
  latinName: PropTypes.string,
  code: PropTypes.string,
  legacyCode: PropTypes.number,
  onChange: PropTypes.func,
  isReadOnly: PropTypes.bool
}

export default BaseInputs



// WEBPACK FOOTER //
// ./src/components/codeLists/baseInputs.js